const key = 'remotion-editor-starter.timeline-collapsed';

export const DEFAULT_TIMELINE_COLLAPSED = false;

export const loadTimelineCollapsed = () => {
  if (typeof localStorage === 'undefined') {
    return DEFAULT_TIMELINE_COLLAPSED;
  }

  const value = localStorage.getItem(key);
  if (value === null) {
    return DEFAULT_TIMELINE_COLLAPSED;
  }
  return value === 'true';
};

export const saveTimelineCollapsed = (collapsed: boolean) => {
  localStorage.setItem(key, collapsed.toString());
};
